export default __webpack_public_path__ + "static/media/woman.7f95a044.png";